import type { FaireProductEntity } from "../../entity_types/product";

export const p_274yupms6a: FaireProductEntity = {
  token: "p_274yupms6a",
  type: "product",
  name: "baking recipe cards",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/7bc59e1eb7e973ef0a186a99f701754e63de80ff7a1a153a3c7dd3cd7cb57a10.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/85084b9f7e80d3f962389f29c2b329214c82a7715c5dc9e6eaaa3028319b1080.jpeg",
    "https://cdn.faire.com/fastly/d28b818261d24636775074ee4642f0eab9557b7ff4879be12f70bfa34fe8640a.jpeg",
    "https://cdn.faire.com/fastly/e40b93863be8bfe5d0eb06178b10b85f8bfe9aac257a2ad13edd117d5b511518.jpeg",
    "https://cdn.faire.com/fastly/0339454924999db0178de17c5cb2ca17bf710ea6ceb41942910319f7e01dc229.jpeg",
    "https://cdn.faire.com/fastly/060186b9ac2adb3e4cd422efd5f010d6ccff305e753a573ce1f06fef2b163dc7.jpeg",
    "https://cdn.faire.com/fastly/c4caf3207f4630a9e83e4dcba5b024c552aba5bd04302db51672b5a86afa4f74.jpeg",
    "https://cdn.faire.com/fastly/77d2ea08b871afe2680289200cba9967b54fe6c4fe60be84a87e302d8e48ef5a.jpeg",
  ],
  priceDollars: 10,
  description:
    'Write down your favorite recipes on the Baking Recipe Cards. There are 12 cards with space for ingredients on one side and instructions on the back, plus a bonus recipe card for (the best!) chocolate chip cookies. \n\n\nDetails:\n\n- Set of 12 recipe cards\n- Bonus chocolate chip cookie recipe from Emily\n- 4" x 6"\n- Printed on eggshell textured paper\n- Original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:07.830Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
